import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-menu" }
const _hoisted_2 = { class: "news" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add a new biotechnology \"Tangram\", and a new Tangram dataset [Biancalani2021Deep], from paper \"Deep learning and alignment of spatially resolved single-cell transcriptomes with Tangram\"")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new MERFISH datasets [Allen2022Molecular_aging, Allen2022Molecular_lps] from paper \"Molecular and spatial signatures of mouse brain aging at single-cell resolution\""),
  /*#__PURE__*/_createElementVNode("p", null, "Add new MERFISH dataset [Booeshaghi2021Isoform] from paper \"MIsoform cell-type specificity in the mouse primary motor cortex\""),
  /*#__PURE__*/_createElementVNode("p", null, "Add new MERFISH dataset [Zhang2023Amolecularly_rawcount] from paper \"A molecularly defined and spatially resolved cell atlas of the whole mouse brain\""),
  /*#__PURE__*/_createElementVNode("p", null, "Add new STARmap dataset [Zeng2023Integrative] from paper \"Integrative in situ mapping of single-cell transcriptional states and tissue histopathology in a mouse model of Alzheimer's disease\""),
  /*#__PURE__*/_createElementVNode("p", null, "Add new STARmap dataset [Shi2022Spatial] from paper \"Spatial Atlas of the Mouse Central Nervous System at Molecular Resolution\""),
  /*#__PURE__*/_createElementVNode("p", null, "Add new Stereo-seq dataset [Fu2021Unsupervised] from paper \"Unsupervised Spatial Embedded Deep Representation of Spatial Transcriptomics\"")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Project datasets (raw and processed) are introduced! 🚀"),
  /*#__PURE__*/_createElementVNode("p", null, "These datasets can be found in biotech category Other.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new 10X Visium dataset \"Visium_Allen\". ")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new Stereo-seq dataset from paper \"Single-cell Stereo-seq reveals induced progenitor cells involved in axolotl brain regeneration\""),
  /*#__PURE__*/_createElementVNode("p", null, "wei2022single")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new MERFISH dataset \"Merfish_Visp\""),
  /*#__PURE__*/_createElementVNode("p", null, "Add new seqFISH dataset \"seqFISH_VISp\"")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add a new technology \"ExSeq\", and new ExSeq dataset from paper \"Expansion sequencing: Spatially precise in situ transcriptomics in intact biological systems\""),
  /*#__PURE__*/_createElementVNode("p", null, "Alon2021Expansion")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new DSP dataset from paper \"High-plex multiomic analysis in ffpe tissue at single-cellular and subcellular resolution by spatial molecular imaging\""),
  /*#__PURE__*/_createElementVNode("p", null, "he2022high")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add a new technology \"DARTFISH\", and a new DARTFISH dataset")
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add a new biotechnology \"BARISTASeq\", and a new BARISTASeq dataset, from paper \"Integrating barcoded neuroanatomy with spatial transcriptional profiling enables identification of gene correlates of projections\""),
  /*#__PURE__*/_createElementVNode("p", null, "Sun2021Integrating")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new t_CyCIF dataset from paper \"Spatial intra-tumor heterogeneity is associated with survival of lung adenocarcinoma patients\""),
  /*#__PURE__*/_createElementVNode("p", null, "Wu2022spatial")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new technology called \"EEL FISH\", and a EEL FISH dataset from paper \"Scalable in situ single-cell profiling by electrophoretic capture of mRNA using EEL FISH\""),
  /*#__PURE__*/_createElementVNode("p", null, "Borm2022Scalable")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new DSP dataset from paper \"Single-nucleus and spatial transcriptome profiling of pancreatic cancer identifies multicellular dynamics associated with neoadjuvant treatment\""),
  /*#__PURE__*/_createElementVNode("p", null, "Hwang2022single")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add new t-CyCIF datasets from paper \"Highly multiplexed immunofluorescence imaging of human tissues and tumors using t-CyCIF and conventional optical microscopes\"."),
  /*#__PURE__*/_createElementVNode("p", null, "Figure10_TMApanels, Figure1112_GBM, Figure56_tonsils, Figure78_PDAC, Figure9_RCC")
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The HDST dataset is updated to add breast cancer data."),
  /*#__PURE__*/_createElementVNode("p", null, "The original paper: High-definition spatial transcriptomics for in situ tissue profiling")
], -1)
const _hoisted_18 = { class: "text item" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("🧰pysodb ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" is available!")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "pysodb is a python package that provides the interface to access the data in SODB!", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 📘 Documentation and Tutorials ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "📈 The download button is activated! ✅")
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add 1 DSP dataset!"),
  /*#__PURE__*/_createElementVNode("p", null, "New dataset: Beechem2022High"),
  /*#__PURE__*/_createElementVNode("p", null, "DSP data of human non-small-cell lung cancer."),
  /*#__PURE__*/_createElementVNode("p", null, "High-plex Multiomic Analysis in FFPE at Subcellular Level by Spatial Molecular Imaging.")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add 1 STARmap dataset!"),
  /*#__PURE__*/_createElementVNode("p", null, "New datasets: Wang2018Three_1k"),
  /*#__PURE__*/_createElementVNode("p", null, "STARmap data of Mouse Cortex!"),
  /*#__PURE__*/_createElementVNode("p", null, "Three-dimensional intact-tissue sequencing of single-cell transcriptional states.")
], -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add 1 slide-seqV2 dataset!"),
  /*#__PURE__*/_createElementVNode("p", null, "New datasets: Biermann2022Dissecting"),
  /*#__PURE__*/_createElementVNode("p", null, "Slide-seqV2 data of Melanoma brain metastasis from a Cell paper of Benjamin Izar lab!"),
  /*#__PURE__*/_createElementVNode("p", null, "Dissecting the treatment-naive ecosystem of human melanoma brain metastasis.")
], -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add 1 10X Visium dataset!"),
  /*#__PURE__*/_createElementVNode("p", null, "New datasets: Barkley2022Cancer"),
  /*#__PURE__*/_createElementVNode("p", null, "10X Visium data of mutiple human cancer samples from a Nature Genetics paper of Itai Yanai lab!"),
  /*#__PURE__*/_createElementVNode("p", null, "Cancer cell states recur across tumor types and form specific interactions with the tumor microenvironment.")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add 2 slide-seqV2 dataset!"),
  /*#__PURE__*/_createElementVNode("p", null, "New datasets: Marshall2022High_human, Marshall2022High_mouse"),
  /*#__PURE__*/_createElementVNode("p", null, "The two datasets are Slide-seqV2 data of mouse/human kidney from a iScience paper of Evan Z. Macosko, Fei Chen, and Anna Greka!"),
  /*#__PURE__*/_createElementVNode("p", null, "High-resolution Slide-seqV2 spatial transcriptomics enables discovery of disease-specific cell neighborhoods and pathways.")
], -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Add 20 Visium data and 1 ST datasets! "),
  /*#__PURE__*/_createElementVNode("p", null, "New datasets: Sun2022Excitatory, Kadur2022Human, Dhainaut2022Spatial, Buzzi2022Spatial, Misra2021Characterizing, Dixon2022Spatially, Pascual2021Dietary Kleshchevnikov2022Cell2location, Juntaro2022MEK, Tower2021Spatial, Gouin2021An Garcia2021Mapping, Melo2021Integrating, Sanchez2021A, Ratz2022Clonal Lebrigand2022The, Konieczny2022Interleukin, Joglekar2021A, Navarro2020Spatial ")
], -1)
const _hoisted_30 = { class: "text item" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", null, "The introduction video of SODB is available! ", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("🔥 Click here to watch the video 🔥")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The MERFISH dataset from (Fang, Rongxin et al, Science 2022) is available! ")
], -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The MERFISH dataset from (Zhang, M. et al, Nature 2022) is available! This is an initial product of BICCN project. ")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The first spatial genomics dataset (Zhao, T. et al, Nature 2022) is available! ")
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The Stereo-seq spatial transcriptomics data from BGI is updated on SODB! ")
], -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "SOView supports interactive region selection, so that user can identify ROI marker genes! ")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "The Visium dataset from (Parigi, Sara M. et al, Nature Communications 2022) is available!")
], -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "New feature of SODB: spatial omics view (SOView)! ")
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "SODB supports mouse hovering to explore spatial data. ")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "text item" }, [
  /*#__PURE__*/_createElementVNode("p", null, "First version of SODB is online! 🎉")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_timeline = _resolveComponent("el-timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_timeline_item, {
            timestamp: "2023.3.21",
            placement: "top",
            color: "#2090FF"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2023.3.20",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.12.16",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.12.12",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.12.11",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.11.29",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.11.28",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.11.16",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.11.15",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.11.04",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.11.03",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.10.28",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.10.27",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.10.17",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.10.16",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.10.8",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_el_link, {
                        type: "primary",
                        href: "https://github.com/TencentAILabHealthcare/pysodb"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_19
                        ]),
                        _: 1
                      }),
                      _hoisted_20
                    ]),
                    _hoisted_21,
                    _createVNode(_component_el_link, {
                      type: "primary",
                      href: "https://pysodb.readthedocs.io/en/latest/"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.10.7",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.9.13",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.8.19",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.8.17",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.8.16",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_27
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.8.15",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.8.14",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_29
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.8.10",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createVNode(_component_el_link, {
                      type: "danger",
                      href: "https://youtu.be/shq8RQI9dd8"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_32
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.8.3",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_33
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.7.23",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_34
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.7.12",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_35
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.7.5",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_36
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.6.23",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_37
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.6.5",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_38
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.5.15",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_39
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.5.6",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_40
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_timeline_item, {
            timestamp: "2022.4.25",
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _hoisted_41
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}